import { useGetIdentity } from "@refinedev/core";
import { Layout as AntdLayout, Space, Typography, Avatar, theme } from "antd";
import { APP_TAGLINE } from "@/theme/tokens";

const { Text } = Typography;

interface Identity {
  name?: string;
  email?: string;
  avatar?: string;
}

/**
 * Header custom com o gradiente da marca e a TAGLINE oficial do MEL.
 * Passado ao ThemedLayout via prop `Header`.
 */
export const MelHeader: React.FC = () => {
  const { token } = theme.useToken();
  const { data: identity } = useGetIdentity<Identity>();

  return (
    <AntdLayout.Header
      className="mel-header"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        height: 64,
        background: "linear-gradient(135deg,#06B6D4 0%,#2DD4BF 100%)",
        boxShadow: "0 2px 16px rgba(6,182,212,0.18)",
      }}
    >
      <Space direction="vertical" size={0}>
        <Text strong style={{ color: "#fff", fontSize: 16, lineHeight: 1.1 }}>
          Painel administrativo
        </Text>
        <Text className="mel-tagline" style={{ color: "#fff" }}>
          {APP_TAGLINE}
        </Text>
      </Space>

      <Space size={12} align="center">
        <Text style={{ color: "#fff" }}>{identity?.name ?? "admin"}</Text>
        <Avatar
          src={identity?.avatar}
          alt={identity?.name}
          style={{ background: "rgba(255,255,255,0.25)", color: token.colorWhite }}
        >
          {(identity?.name ?? "A").charAt(0).toUpperCase()}
        </Avatar>
      </Space>
    </AntdLayout.Header>
  );
};
